import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { DisplayMode } from '@r-core';

export const newIslandMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'New Island',
		isVisible: ({ refMap, controller: { navigation, readonly }}): boolean => {
			// const panel = ui.pointer.context.ref as unknown as Panel;
			// const island = panel?.refMap.island;
			const { panel, island } = refMap;
			if (readonly || !island) return false;

			const [sourceConnection] = island.connections.getSourceConnections();
			// console.log('isVisiable', panel.label, connection);
			return navigation.displayMode === DisplayMode.Overhead && sourceConnection?.sourcePanelId !== panel.id;
		},
		onClick: ({ controller, context }): void => {
			controller.publishRequestedAction('new_island', context.id);
		}
	}
};
